import React from 'react';

// Types
import { SurfaceFilters } from 'Shared/types/Capture.types';

// Components
import { WpButton } from 'Wpds/components/button';
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import SurfaceFilterBlock from './SurfaceFilterComponents/SurfaceFilterBlock';
import IntegrationsFilterList from './SurfaceFilterComponents/IntegrationsFilterList';
import InsightFilterList from './SurfaceFilterComponents/InsightFilterList';
import StatusFilterList from './SurfaceFilterComponents/StatusFilterList';
import UsersFilterList from './SurfaceFilterComponents/UsersFilterList';
import NameFilter from './SurfaceFilterComponents/NameFilter';

// Styles
import './SurfaceAIFilters.scss';

type Props = {
  surfaceData;
  filters?: SurfaceFilters;
  updateFilters?: Function;
};

const SurfaceAIFilters = ({
  surfaceData,
  filters = {
    name: '',
    typeName: [],
    insight: [],
    status: [],
    users: [],
  },
  updateFilters,
}: Props) => {
  const baseClassName = 'SurfaceAIFilters';

  const handleClearFiltersClick = () => {
    updateFilters({
      name: '',
      typeName: [],
      insight: [],
      status: [],
      users: [],
    });
  };

  const name = filters.name;
  const typeCount = filters.typeName.length;
  const insightCount = filters.insight.length;
  const statusCount = filters.status.length;
  const usersCount = filters.users.length;

  const showClearAll = Boolean(typeCount || insightCount || statusCount || usersCount || name);

  return (
    <WpContainer className={baseClassName}>
      <WpContainerBody padding="05">
        <div className={`${baseClassName}__header`}>
          <div className={`${baseClassName}__header__title`}>Filters</div>
          {showClearAll && (
            <WpButton variant="tertiary" size="sm" onClick={handleClearFiltersClick}>
              clear all
            </WpButton>
          )}
        </div>
        <div className={`${baseClassName}__block`}>
          <NameFilter updateFilters={updateFilters} value={name} />
        </div>
        <div className={`${baseClassName}__block`}>
          <SurfaceFilterBlock title="Teammates" count={usersCount}>
            <UsersFilterList selectedUsers={filters.users} updateFilters={updateFilters} />
          </SurfaceFilterBlock>
        </div>
        <div className={`${baseClassName}__block`}>
          <SurfaceFilterBlock title="Integrations" count={typeCount}>
            <IntegrationsFilterList
              surfaceData={surfaceData}
              selectedTypes={filters.typeName}
              updateFilters={updateFilters}
            />
          </SurfaceFilterBlock>
        </div>
        <div className={`${baseClassName}__block`}>
          <SurfaceFilterBlock title="Insight" count={insightCount}>
            <InsightFilterList
              surfaceData={surfaceData}
              selectedInsights={filters.insight}
              updateFilters={updateFilters}
            />
          </SurfaceFilterBlock>
        </div>
        <div className={`${baseClassName}__block`}>
          <SurfaceFilterBlock title="Status" count={statusCount}>
            <StatusFilterList
              surfaceData={surfaceData}
              selectedStatuses={filters.status}
              updateFilters={updateFilters}
            />
          </SurfaceFilterBlock>
        </div>
      </WpContainerBody>
    </WpContainer>
  );
};

export default SurfaceAIFilters;
